<template>
  <v-form ref="psychStepOneForm" v-model="valid">
    <v-container>
      <v-row>
        <v-col cols="12" md="8" class="mb-0 pb-0">
          <p class="mb-0">
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistReg.generalInformation"
              )
            }}
          </p>
          <p class="mb-0 caption">
            {{ $vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.desk") }}
          </p>
        </v-col>
      </v-row>
      <v-row class="pt-0 mt-0">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="lastname.uk"
            :rules="[...lastnameRulesUA, noRussianRule]"
            label="Прізвище"
            required
            @input="saveDebounced"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="firstname.uk"
            :rules="[...nameRulesUA, noRussianRule]"
            label="Ім'я"
            required
            @input="saveDebounced"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="patronymic.uk"
            :rules="[noRussianRule]"
            label="По батькові"
            required
            @input="saveDebounced"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                :label="
                  $vuetify.lang.t(
                    `$vuetify.main.psychologistReg.stepOne.dateOfBirth`
                  )
                "
                prepend-icon="mdi-calendar"
                readonly
                :rules="birthdayRules"
                v-bind="attrs"
                v-on="{ keydown: on.keydown }"
                @click.native="menu2 = true"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              :active-picker.sync="birthdayPicker"
              no-title
              :max="maxBirthday"
              min="1930-01-01"
              locale="uk-UA"
              :first-day-of-week="1"
              @change="menu2 = false; saveDebounced()"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4" class="pt-2">
          <v-text-field
            v-model="citizenship"
            :label="
              $vuetify.lang.t(
                `$vuetify.main.psychologistReg.stepOne.citizenship`
              )
            "
            required
            :rules="[...citizenshipRules, noRussianRule]"
            class="pt-5 mt-0"
            @input="saveDebounced"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pt-2">
          <v-select
            v-model="sex"
            :items="sexList"
            item-value="id"
            item-text="title"
            :label="
              $vuetify.lang.t(
                `$vuetify.main.psychologistReg.stepOne.sex`
              )
            "
            required
            :rules="sexRules"
            class="pt-5 mt-0"
            @input="saveDebounced"
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="needsPhone">
        <v-col col="12" md="7" lg="5">
          <vue-phone-number-input
            v-model="unverifiedPhone"
            :default-country-code="defaultCountry"
            :preferred-countries="countriesList"
            :loader="hasLoaderActive"
            :error="hasErrorActive"
            :translations="translations"
            @update="updatedPhone"
            show-code-on-list
            :required="true"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <p class="mb-0">
            {{
              $vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.education")
            }}
          </p>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12" md="12">
          <div
            v-for="(item, index) in educationItems"
            :key="index"
          >
            <v-card class="mb-4">
              <v-card-subtitle>
                <div class="d-flex align-center">
                  <div class="flex-grow-1">
                    {{ $vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.education") }} №{{index + 1}}
                  </div>

                  <div class="ml-2">
                    <div>
                      <v-btn
                        icon
                        color="red"
                        class="ed-remove-btn"
                        @click="removeEdItem(index)"
                        :disabled="educationItems.length === 1"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="item.year"
                      :label="
                        $vuetify.lang.t(
                          `$vuetify.main.psychologistReg.stepOne.yearOfEnding`
                        )
                      "
                      type="text"
                      :rules="yearRules"
                      class="mt-0 pt-0"
                      @input="saveDebounced"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="10">
                    <v-text-field
                      v-model="item.desc_uk"
                      label="Опис"
                      type="text"
                      :rules="[...descRulesUA, noRussianRule]"
                      class="mt-0 pt-0"
                      @input="saveDebounced"
                    ></v-text-field>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </div>

          <div class="d-flex mt-2 mb-5">
            <v-btn
              color="primary"
              @click="addEdItem"
              :disabled="educationItems.length >= 20"
            >
              {{ $vuetify.lang.t(`$vuetify.main.psychologistReg.stepOne.add_education`) }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="mb-0 pb-2">
          <p class="mb-0 pb-0">
            {{
              $vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.photoDesc")
            }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <v-row>
            <v-file-input
              class="diploma-and-certificates"
              v-model="photo"
              accept="image/png, image/jpeg, image/bmp, image/webp, image/gif, image/jpg, application/vnd.oasis.opendocument.text ,application/rtf, text/rtf, application/msword, application/pdf"
              @click:clear="clearFiles"
              @change="addFiles"
              show-size
              counter
              append
              multiple
              :label="
                $vuetify.lang.t(
                  `$vuetify.main.psychologistReg.stepOne.diploma_and_certificates`
                )
              "
            ></v-file-input>
          </v-row>
          <v-row>
            <p class="pl-8 pt-0 mt-0 font-weight-thin">
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistReg.stepOne.diploma_and_certificates_desk"
                )
              }}
            </p>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import debounce from '@/utils/debounce'
import { noRussianRule } from "@/utils/noRussian";

export default {
  name: "stepOne",
  data() {
    return {
      saveDebounced: function() {},
      userData: null,
      defaultCountry: "",
      countriesList: ["UA", "RU", "BY", "MD"],
      hasLoaderActive: false,
      hasErrorActive: false,
      unverifiedPhone: "",
      photo: [],
      photos: [],
      currFiles: [],
      valid: false,
      firstname: { ru: "", uk: "" },
      lastname: { ru: "", uk: "" },
      patronymic: { ru: "", uk: "" },
      university: "",
      faculty: "",
      speciality: "",
      sex: '',
      sexList: [
        {
          id: 0,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.female"
          ),
        },
        {
          id: 1,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.male"
          ),
        }
      ],
      educationItems: [{ year: "", desc_uk: "", desc_ru: "" }],
      scienceDegree: [],
      yearOfEnding: "",
      citizenship: "",
      email: "",
      scienceDegreeList: [
        {
          id: "bachelors",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.bachelors"
          ),
        },
        {
          id: "master",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.master"
          ),
        },
        {
          id: "doctoral",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.doctoral"
          ),
        },
        {
          id: "candidate_of_sciences",
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.candidate_of_sciences"
          ),
        },
      ],
      // empty until chosen: the picker used to start at today and the year had to be changed by the small header
      date: "",
      birthdayPicker: null,
      menu: false,
      modal: false,
      menu2: false,
    };
  },
  created() {
    this.$eventHub.$on("psych-step-one-form_validate-form", this.validate);
    this.loadUser();
    this.saveDebounced = debounce(() => {
      this.saveData();
    }, 400)
  },
  beforeDestroy() {
    this.$eventHub.$off("psych-step-one-form_validate-form", this.validate);
    this.saveDebounced.cancel();
  },
  watch: {
    // a birthday is picked year first, then month and day
    menu2(open) {
      open && setTimeout(() => (this.birthdayPicker = "YEAR"));
    },
    userData() {
      let countryCode = this.userData.countryCode;
      let nationalNumber = this.userData.nationalNumber;
      switch (countryCode) {
        case "UA":
          if (nationalNumber) {
            if (Array.from(nationalNumber).length > 9) {
              this.hasErrorActive = true;
              this.userData.isValid = false;
            } else {
              this.hasErrorActive = false;
            }
          }
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    translations() {
      return {
        countrySelectorLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorLabel"
        ),
        countrySelectorError: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorError"
        ),
        phoneNumberLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.phoneNumberLabel"
        ),
        example: this.$vuetify.lang.t("$vuetify.view.signIn.example"),
      };
    },
    needsPhone() {
      let currentLoginProvider = this.$store.getters['user/getLoginProvider'];
      if (currentLoginProvider.provider_id != null && 
        currentLoginProvider.provider_id.trim() !== ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    nameRules() {
      return [(v) => !!v || `Поле "Имя" обязательно для заполнения`];
    },
    lastnameRules() {
      return [(v) => !!v || `Поле "Фамилия" обязательно для заполнения`];
    },
    nameRulesUA() {
      return [(v) => !!v || `Поле "Ім'я" обов'язково під час заповнення`];
    },
    lastnameRulesUA() {
      return [(v) => !!v || `Поле "Прізвище" обов'язково під час заповнення`];
    },
    // the API accepts psychologists of 18 and older
    maxBirthday() {
      const d = new Date();
      d.setFullYear(d.getFullYear() - 18);
      return d.toISOString().substr(0, 10);
    },
    birthdayRules() {
      return [
        (v) => !!v || "Вкажіть дату народження",
        (v) => v <= this.maxBirthday || "Дата народження: вам має бути більше 18 років",
      ];
    },
    yearRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearRules1"
          ),
        (v) =>
          v.length === 4 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearRules2"
          ),
      ];
    },
    descRules() {
      return [(v) => !!v || this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.descRules")];
    },
    descRulesUA() {
      return [(v) => !!v || this.$vuetify.lang.t("$vuetify.main.psychologistReg.stepOne.descRulesUA")];
    },
    emailRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.emailRules1"
          ),
        (v) =>
          /.+@.+/.test(v) ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.emailRules2"
          ),
      ];
    },
    universityRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.universityRules"
          ),
      ];
    },
    facultyRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.facultyRules"
          ),
      ];
    },
    specialityRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.specialityRules"
          ),
      ];
    },
    sexRules() {
      return [
        (v) =>
          (v === 0 || !!v) ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.sexRules"
          ),
      ];
    },
    yearOfEndingRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearOfEndingRules1"
          ),
        (v) =>
          v.length === 4 ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.yearOfEndingRules2"
          ),
      ];
    },
    citizenshipRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.psychologistReg.stepOne.citizenshipRules"
          ),
      ];
    },
  },
  methods: {
    noRussianRule,
    updatedPhone(data) {
      this.userData = data;
    },
    loadUser() {
      if (this.user.psychologistQuestionnaire.profile.name) {
        this.firstname = this.user.psychologistQuestionnaire.profile.name;
      }
      if (this.user.unverifiedPhone) {
        this.unverifiedPhone = this.user.unverifiedPhone;
      }
      if (this.user.unverifiedPhoneCountryCode) {
        this.defaultCountry = this.user.unverifiedPhoneCountryCode;
      }
      if(this.user.psychologistQuestionnaire.profile.surname) {
        this.lastname = this.user.psychologistQuestionnaire.profile.surname;
      }
      if (this.user.psychologistQuestionnaire.profile.middle_name) {
        this.patronymic = this.user.psychologistQuestionnaire.profile.middle_name;  
      }
      // a draft may hold today's date that the old picker put by default
      if(this.user.psychologistQuestionnaire.profile.birthday && this.user.psychologistQuestionnaire.profile.birthday <= this.maxBirthday) {
        this.date = this.user.psychologistQuestionnaire.profile.birthday;
      }
      if(this.user.psychologistQuestionnaire.profile.sex || this.user.psychologistQuestionnaire.profile.sex === 0) {
        this.sex = this.user.psychologistQuestionnaire.profile.sex;
      }
      if(this.user.psychologistQuestionnaire.profile.citizenship) {
        this.citizenship = this.user.psychologistQuestionnaire.profile.citizenship;
      }
      if (this.user.psychologistQuestionnaire.profile.education) {
        let education = this.user.psychologistQuestionnaire.profile.education;
        this.educationItems = [];
        if (education.ru && education.uk) {
          education.ru.forEach((edItem, index) => {
            if (education.uk[index] && education.uk[index].year == edItem.year) {
              this.educationItems.push({ 
                year: edItem.year, 
                desc_uk: education.uk[index].desc,
                desc_ru: edItem.desc, 
              });
            }
          });
        }
      }
    },
    addEdItem() {
      if (this.educationItems.length < 20) {
        this.educationItems.push({ year: "", desc_uk: "", desc_ru: "" });
      }
    },
    removeEdItem(index) {
      if (this.educationItems.length > 1) {
        this.educationItems.splice(index, 1);
      }
    },
    saveData() {
      let educationItems_uk = [];
      let educationItems_ru = [];
      this.educationItems.forEach(educationItem => {
        educationItems_uk.push({
          year: educationItem.year,
          desc: educationItem.desc_uk,
        });
        educationItems_ru.push({
          year: educationItem.year,
          desc: educationItem.desc_uk,
        });
      });
      let education = {
        uk: educationItems_uk,
        ru: educationItems_ru,
      }
      if (this.needsPhone) {
        this.$store.commit("user/SET_USER_UNVERIFIED_PHONE", {
          phone: this.userData.formattedNumber,
          code: this.userData.countryCode,
        });
      }
      this.$store.dispatch("user/setQuestionnaireProfile", {
        // the platform is Ukrainian only, the API still keeps a ru copy of the texts
        name: { ru: this.firstname.uk, uk: this.firstname.uk },
        surname: { ru: this.lastname.uk, uk: this.lastname.uk },
        middle_name: { ru: this.patronymic.uk, uk: this.patronymic.uk },
        birthday: this.date,
        sex: this.sex,
        citizenship: this.citizenship,
        education: education,
        localVal: this.localVal,
      });
    },
    validate() {
      this.$refs.psychStepOneForm.validate();

      if (this.needsPhone && (!this.userData || (this.userData && !this.userData.isValid))) {
        this.hasErrorActive = true;
      } else {
        if (this.valid) {
          this.saveData();
          this.$store.dispatch("user/setUserCertificates", this.photo);
          this.$eventHub.$emit("switch-psych-registration-tab", 2);
        }
      }
    },
    addFiles() {
      if (event.type === "blur" || event.type === "click") return;
      this.photos.push(...this.photo);
      this.photo = this.photos;
    },
    clearFiles() {
      this.photos = [];
      this.photo = [];
    },
  },
};
</script>

<style lang="scss">
/* .ed-remove-btn {
    margin-top: -8px;
    margin-right: -8px;
} */
</style>
